import { render, staticRenderFns } from "./funds-hold-request.vue?vue&type=template&id=0f5a25fd&scoped=true&"
import script from "./funds-hold-request.vue?vue&type=script&lang=js&"
export * from "./funds-hold-request.vue?vue&type=script&lang=js&"
import style0 from "./funds-hold-request.vue?vue&type=style&index=0&id=0f5a25fd&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f5a25fd",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCol,VRow})
